import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import Swiper from 'swiper';
import lazyload from '@/utility/lazyload';
import { requireAll, triggerEvent } from '@/utility/functions';

window.Swiper = Swiper;

Alpine.plugin(focus);
Alpine.plugin(intersect);

window.Alpine = Alpine;

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;

// features
require('@/features/mobile_nav');
require('@/features/file_input');
require('@/features/register');
require('@/features/checkout');
require('@/features/slide-in-on-scroll');
require('@/features/toggle_show_target');
require('@/features/account');

// init Alpine
requireAll(require.context('@/alpine_funcs/', true, /\.js$/));

Alpine.start();

// init main
triggerEvent(window, 'vueloaded');

let lazy = document.querySelectorAll('[data-lazyload]');

for(let l = 0; l < lazy.length; l++) {
  lazyload(lazy[l]);
}
